module.exports = __webpack_public_path__ + "static/media/03.6f5c43ca.png";